"use client"

import styled from "@emotion/styled"
import { Link } from "@eurodrive/utils"
import { Breadcrumbs, Typography } from "@mui/material"

import Image from "next/image"
import { Desktop, Mobile } from "./MediaQueries"
import { sharedColors } from "./theme/colors"

const StyledContainer = styled.div<{ noPadding?: boolean }>`
  padding: ${(props) => (props.noPadding ? "" : "12px 0 ")};
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => (props.noPadding ? "" : "16px 0 ")};
  }
`

const StyledLink = styled.div`
  text-decoration: none;
`

// Updated interface to match the new breadcrumbs object structure
interface CustomBreadcrumbsProps {
  breadcrumbs: {
    selfObject: { title: string; url: string }
    parents: { title: string; url: string }[]
  }
  children?: JSX.Element
  noPadding?: boolean
}

export const CustomBreadcrumbs: React.FC<CustomBreadcrumbsProps> = ({
  breadcrumbs,
  children,
  noPadding,
}) => {
  const { selfObject, parents } = breadcrumbs
  return (
    <StyledContainer noPadding={noPadding}>
      {children}
      <Breadcrumbs
        separator={
          <Image src="/icons/breadcrumb.svg" alt="" width={5} height={10} />
        }
        aria-label="מיקומך באתר"
      >
        {parents.map((item, index) => (
          <StyledLink key={index.toString()}>
            <Link
              style={{
                textDecoration: "none",
              }}
              href={item.url}
            >
              <Desktop>
                <Typography variant="body2" color={sharedColors.grey}>
                  {item.title}
                </Typography>
              </Desktop>
              <Mobile>
                <Typography variant="body3" color={sharedColors.grey}>
                  {item.title}
                </Typography>
              </Mobile>
            </Link>
          </StyledLink>
        ))}
        <span aria-current="page">
          <Desktop>
            <Typography variant="body2" color={sharedColors.black}>
              {selfObject.title}
            </Typography>
          </Desktop>
          <Mobile>
            <Typography variant="body3" color={sharedColors.black}>
              {selfObject.title}
            </Typography>
          </Mobile>
        </span>
      </Breadcrumbs>
    </StyledContainer>
  )
}

export default CustomBreadcrumbs
